import React from 'react';

const SectionTitle: React.FC = ({ children }) => {
    return <div className="text-lg">{children}</div>;
};

export default SectionTitle;
